const host = typeof window !== 'undefined' ? window.location.hostname : ''
const isDevDomain = host === 'localhost' || host.includes('-dev.oujat.com') || host === 'dev.oujat.com'

export const API_BASE_URL = isDevDomain ? 'https://api-dev.oujat.com' : 'https://api.oujat.com'
// export const API_BASE_URL = 'http://localhost:4000'
const DEV_MEDIA_URL = 'https://oujat-storage.s3.us-east-2.amazonaws.com'
const PROD_MEDIA_URL = 'https://oujat-storage-prod.s3.us-east-2.amazonaws.com'
export const MEDIA_URL = (process.env.REACT_APP_MEDIA_URL || (isDevDomain ? DEV_MEDIA_URL : PROD_MEDIA_URL)).replace(
  /\/$/,
  ''
)

export const SOCKET_URL = API_BASE_URL
export const ApiEndPoints = {
  BASE_URL: API_BASE_URL,
  SOCKET_URL: SOCKET_URL,
  AUTH: {
    register: `${API_BASE_URL}/api/v1/auth/customer/register`,
    updateregister: id => `${API_BASE_URL}/api/v1/auth/${id}`,
    register_verify_otp: type => `${API_BASE_URL}/api/v1/auth/verify/otp/${type} `,
    resend_otp: type => `${API_BASE_URL}/api/v1/auth/resend/otp/${type} `,
    update_profile: `${API_BASE_URL}/api/v1/auth `,
    login: type => `${API_BASE_URL}/api/v1/auth/login/${type} `,
    loginwithgoogle: `${API_BASE_URL}/api/v1/social/google/signin/customer`,
    logout: `${API_BASE_URL}/api/v1/auth/logout`,
    me: `${API_BASE_URL}/api/v1/auth/me`,
    forgot_password: `${API_BASE_URL}/api/v1/auth/forgot/password`,
    verify_otp: `${API_BASE_URL}/api/v1/auth/verify/otp`,
    reset_password: `${API_BASE_URL}/api/v1/auth/reset/password`,
    change_password: `${API_BASE_URL}/api/v1/dealer/auth/change-password`,
    change_email: `${API_BASE_URL}/api/v1/dealer/auth/change-email`,
    change_email_verify_otp: `${API_BASE_URL}/api/v1/dealer/auth/change-email-verify-otp`,
    profileImage: `${API_BASE_URL}/api/v1/auth/profile/image`,
    profile: `${API_BASE_URL}/api/v1/auth/profile`
  },
  SUSCRIPTION_PAYMET: {
    suscriptionplan: `${API_BASE_URL}/api/v1/admin/plan-features`,
    freeplanforever: id => `${API_BASE_URL}/api/v1/subscription/lifetime/free/${id}`,
    cancel: `${API_BASE_URL}/api/v1/subscription/cancel`,
    paypal: `${API_BASE_URL}/api/v1/paypal/create-payment/subscription`,
    pawapay: `${API_BASE_URL}/api/v1/pawapay/create-payment/subscription`,
    stripe: `${API_BASE_URL}/api/v1/stripe/create/checkout-session/subscription`,
    wallet: `${API_BASE_URL}/api/v1/wallet/subscription/payment`,
    addcarddetails: `${API_BASE_URL}/api/v1/stripe/add/card-details`,
    startfreeplan: id => `${API_BASE_URL}/api/v1/subscription/free/trial/${id}`,
    featuresbyid: id => `${API_BASE_URL}/api/v1/admin/plan-features/${id}`,
    addcustomizableplan: `${API_BASE_URL}/api/v1/subscription/customized`,
    /** GET ?planId=&planType=monthly|yearly — server proration / downgrade rules */
    changeQuote: `${API_BASE_URL}/api/v1/subscription/change-quote`
  },
  QMS: {
    list: `${API_BASE_URL}/api/v1/qms`,
    create: `${API_BASE_URL}/api/v1/qms`,
    listbyid: id => `${API_BASE_URL}/api/v1/qms/${id}`,
    quotationAccept: id => `${API_BASE_URL}/api/v1/qms/${id}`,
    quote: `${API_BASE_URL}/api/v1/qms/quotation/all`,
    privatequoteReject: id => `${API_BASE_URL}/api/v1/qms/reject/${id}`,
    tabcount: `${API_BASE_URL}/api/v1/qms/tab-counts/customer`,
    draftList: `${API_BASE_URL}/api/v1/qms/drafts`,
    draftById: id => `${API_BASE_URL}/api/v1/qms/draft/${id}`,
    draftUpsert: `${API_BASE_URL}/api/v1/qms/draft`,
    draftDelete: id => `${API_BASE_URL}/api/v1/qms/draft/${id}`,
    guestDraft: `${API_BASE_URL}/api/v1/qms/guest-draft`,
    guestDraftByToken: token => `${API_BASE_URL}/api/v1/qms/guest-draft/${token}`,
    guestDraftEmail: token => `${API_BASE_URL}/api/v1/qms/guest-draft/${token}/email`,
    guestDraftClaim: token => `${API_BASE_URL}/api/v1/qms/guest-draft/${token}/claim`,
    addressBookList: `${API_BASE_URL}/api/v1/addressbook/list/filtered`
  },
  DASHBOARD: {
    count: `${API_BASE_URL}/api/v1/dashboard/customer`,
    favoriteService: `${API_BASE_URL}/api/v1/service/all/favorites`,
    favoriteAgent: `${API_BASE_URL}/api/v1/storefront/favorite/agents`
  },
  USERS: {
    list: type => `${API_BASE_URL}/api/v1/admin/users/${type}`,
    status: user_id => `${API_BASE_URL}/api/v1/admin/users/verify/${user_id}`
  },
  PRIVACY_POLICY: {
    list: `${API_BASE_URL}/api/admin/v1/privacypolicy/list`,
    edit: id => `${API_BASE_URL}/api/admin/v1/privacypolicy/update/${id}`
  },
  Terms_AND_CONDITIONS: {
    list: `${API_BASE_URL}/api/admin/v1/terms/list`,
    edit: id => `${API_BASE_URL}/api/admin/v1/terms/update/${id}`
  },
  FAQ: {
    list: `${API_BASE_URL}/api/admin/v1/faq/list`,
    create: `${API_BASE_URL}/api/admin/v1/faq`,
    edit: id => `${API_BASE_URL}/api/admin/v1/faq/update/${id}`,
    delete: id => `${API_BASE_URL}/api/admin/v1/faq/remove/${id}`
  },
  NOTIFICATION: {
    list: `${API_BASE_URL}/api/v1/notification/user`,
    sent_fcm_token: `${API_BASE_URL}/api/v1/notification/token/user`,
    delete: id => `${API_BASE_URL}/api/v1/notification/user`,
    markAsRead: id => `${API_BASE_URL}/api/v1/notification/user`
  },
  QUOTATIONS: {
    list: `${API_BASE_URL}/api/v1/qms/quotation`,
    listbyid: id => `${API_BASE_URL}/api/v1/qms/quotes/${id}`,
    compareQuotation: `${API_BASE_URL}/api/v1/quotation/compare`,
    assesmentquote: id => `${API_BASE_URL}/api/v1/quotation/${id}`
  },
  SERVICE: {
    list: `${API_BASE_URL}/api/v1/service/customer`,
    listbyid: id => `${API_BASE_URL}/api/v1/service/customer/${id}`
  },
  COUNT: {
    list: type => `${API_BASE_URL}/api/v1/misc/services/counts/${type}`
  },
  CATEGORY: {
    list: type => `${API_BASE_URL}/api/v1/misc/category/${type}`
  },
  STOREFRONT: {
    getByUserId: userId => `${API_BASE_URL}/api/v1/storefront/customer/${userId}`,
    review: userId => `${API_BASE_URL}/api/v1/misc/storefront/reviews/${userId}`
  },
  Favorite: {
    follow: userId => `${API_BASE_URL}/api/v1/storefront/favorite/${userId}`,
    add: userId => `${API_BASE_URL}/api/v1/service/favorite/${userId}`
  },
  Chat: {
    add: userId => `${API_BASE_URL}/api/v1/chat/conversation/start/${userId}`,
    adminUserConversation: groupType => `${API_BASE_URL}/api/v1/chat/conversation/admin-user/${groupType}`
  },
  ORDER: {
    list: `${API_BASE_URL}/api/v1/order/all/customer`,
    listbyid: id => `${API_BASE_URL}/api/v1/order/${id}`,
    cancelOrder: order_id => `${API_BASE_URL}/api/v1/order/cancel/${order_id}`,
    makePayment: `${API_BASE_URL}/api/v1/payment/options`,
    acceptOrder: id => `${API_BASE_URL}/api/v1/order/accept/post/cost/${id}`,
    confirmOrder: id => `${API_BASE_URL}/api/v1/order/decline/post/cost/${id}`,
    submitReview: id => `${API_BASE_URL}/api/v1/order/submit/review/${id}`,
    downloadInvoice: id => `${API_BASE_URL}/api/v1/order/cancelled/download/invoice/${id}`,
    lateOrder: id => `${API_BASE_URL}/api/v1/order/late/${id}`,
    completeOrderInvoice: id => `${API_BASE_URL}/api/v1/order/download/invoice/${id}`
  },
  PAYMENT: {
    paypal: `${API_BASE_URL}/api/v1/paypal/create-payment`,
    stripe: `${API_BASE_URL}/api/v1/stripe/create/checkout-session`,
    pawapay: `${API_BASE_URL}/api/v1/pawapay/create-payment`,
    wallet: `${API_BASE_URL}/api/v1/wallet/order/payment`
  },
  Wallet: {
    get: `${API_BASE_URL}/api/v1/wallet/`,
    getTransaction: `${API_BASE_URL}/api/v1/transaction`
  },
  addMoney: {
    paypal: `${API_BASE_URL}/api/v1/wallet/create/paypal/checkout-session`,
    stripe: `${API_BASE_URL}/api/v1/wallet/create/stripe/checkout-session`
  },
  DisputeCenter: {
    list: `${API_BASE_URL}/api/v1/dispute`,
    listbyid: id => `${API_BASE_URL}/api/v1/dispute/${id}`,
    orderlist: `${API_BASE_URL}/api/v1/order/list/dispute`,
    createdispute: `${API_BASE_URL}/api/v1/dispute`
  },
  AddressBook: {
    list: `${API_BASE_URL}/api/v1/addressbook`,
    listbyid: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    personalcontact: `${API_BASE_URL}/api/v1/addressbook`,
    businesscontact: `${API_BASE_URL}/api/v1/addressbook`,
    editpersonalcontact: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    editbusinesscontact: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/addressbook/${id}`,
    pastorder: role => `${API_BASE_URL}/api/v1/order/past/list/${role}`,
    recentchats: `${API_BASE_URL}/api/v1/addressbook/past/chats`,
    downloadpersonalcontact: `${API_BASE_URL}/api/v1/addressbook/personal/contact/template`,
    downloadbusinesscontact: `${API_BASE_URL}/api/v1/addressbook/business/contact/template`,
    uploadpersonalcontact: `${API_BASE_URL}/api/v1/addressbook/upload/personal-contact`,
    uploadbusinesscontact: `${API_BASE_URL}/api/v1/addressbook/upload/business-contact`,
    addaddresses: `${API_BASE_URL}/api/v1/addressbook/multiple`
  },
  TEAM: {
    list: `${API_BASE_URL}/api/v1/sub-user/customer/list`,
    add: `${API_BASE_URL}/api/v1/sub-user/customer`,
    update: id => `${API_BASE_URL}/api/v1/sub-user/${id}`,
    listbyid: id => `${API_BASE_URL}/api/v1/sub-user/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/sub-user/${id}`,
    count: `${API_BASE_URL}/api/v1/sub-user/card-data/customer`
  },
  ROLE: {
    list: `${API_BASE_URL}/api/v1/role`,
    add: `${API_BASE_URL}/api/v1/role`,
    update: id => `${API_BASE_URL}/api/v1/role/${id}`,
    listbyid: id => `${API_BASE_URL}/api/v1/role/${id}`,
    delete: id => `${API_BASE_URL}/api/v1/role/${id}`,
    listById: id => `${API_BASE_URL}/api/v1/role/${id}`
  },
  COMMON: {
    countries: `${API_BASE_URL}/api/v1/utils/common/countries`,
    states: `${API_BASE_URL}/api/v1/utils/common/states`,
    cities: `${API_BASE_URL}/api/v1/utils/common/cities`
  }
}
